<template>
  <span class="key-value">
    <span v-if="keyValue != null">
        {{value}}
        <!-- <i class="fa fa-exclamation-circle text-red" v-if="!showErrors && (keyValue.possibleError || keyValue.error)" :tooltip="keyValue.error ? 'Denne værdi er fejlagtigt indrapporteret. Værdien kan fremfindes i virksomhedens årsrapport.' : 'Denne værdi kan være fejlagtigt indrapporteret. Vi anbefaler at du bekræfter værdien i regnskabets PDF.'"></i> -->
    </span>
    <span v-else>-</span>
  </span>
</template>

<script>
export default {
  name: 'keyValue',
  props: ['keyValue', 'thousands', 'percentage', 'showUnit', 'showErrors'],
  data () {
    return {}
  },
  computed: {
    value: function () {
      if (this.percentage) {
        return this.keyValue.value == null ? '-' : parseFloat(this.keyValue.value).toFixed(2).replace('.', ',') + '%'
      } else if (this.keyValue && this.keyValue.value != null) {
          var final = this.keyValue.value
          if (this.thousands) final = Math.round(this.keyValue.value / 1000) + '’ ' + this.keyValue.unit
          return final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else return '-'
    }
  }
}
</script>

<style lang="less" scoped>
  i.fa {
    display: inline-block;
    margin-left: 8px;
    font-size: 17px;
    position: relative;
    top: -2px;
  }
</style>
